export default __webpack_public_path__ + "public/assets/images/de7fa16896acf7ded6bb8e0cc8ae796b.png";